export default "__VITE_ASSET__RsieQWqk__"